import { FieldLabel } from '@/components/design-system/field';
import { TooltipWrapper } from '@/components/ui/TooltipWrapper';
import type { TranslationKey } from '@/i18n/i18n';
import { cn } from '@/utils/cn';
import { CircleHelp } from 'lucide-react';
import type { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface FormFieldLabelProps {
  label: TranslationKey;
  tooltip?: TranslationKey;
  isRequired?: boolean;
  fieldError?: FieldError;
  className?: string;
  onClick?: () => void;
}

export const FormFieldLabel = ({
  label,
  tooltip,
  isRequired = false,
  fieldError,
  className,
  onClick
}: FormFieldLabelProps) => {
  const { t } = useTranslation();

  return (
    <FieldLabel
      className={cn(
        'inline-flex items-center gap-1 text-sm leading-[1.4] font-bold text-neutral-400',
        fieldError && 'text-error-500',
        onClick && 'cursor-pointer',
        className
      )}
      onClick={onClick}
    >
      {t(label)}
      {isRequired && (
        <span className="text-error-500" aria-hidden="true">
          *
        </span>
      )}
      {tooltip && (
        <TooltipWrapper
          delayDuration={200}
          trigger={
            <CircleHelp
              className="h-3.5 w-3.5 cursor-help text-neutral-500 transition-colors hover:text-neutral-950"
              onClick={(e) => {
                e.stopPropagation();
              }}
            />
          }
          content={<p className="max-w-xs text-sm">{t(tooltip)}</p>}
        />
      )}
    </FieldLabel>
  );
};
